import React, { useState } from 'react';
import classNames from 'classnames';

import styles from './TextArea.module.scss';
import { Text, textVariantsEnum } from '../Text';

export const TextAreaComponent = React.forwardRef(
  (
    {
      id,
      label,
      placeholder,
      className,
      style,
      errorMessage,
      rows = 3,
      hasError,
      disabled,
      value,
      onChange = () => null,
      onFocus = () => null,
      onBlur = () => null,
      onClick = () => null,
      ...rest
    },
    ref
  ) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = (e) => {
      if (disabled) return;
      setIsFocused(true);
      onFocus(e);
    };

    const handleBlur = (e) => {
      if (disabled) return;
      setIsFocused(false);
      onBlur(e);
    };

    const textAreaClass = classNames(
      styles.textArea,
      {
        [styles.textArea_focused]: isFocused,
        [styles.textArea_error]: !!errorMessage || hasError,
        [styles.textArea_disabled]: disabled,
      },
      className
    );

    return (
      <div className={textAreaClass} style={style}>
        {!!label && (
          <Text
            variant={textVariantsEnum.Text_sm}
            color="gray-700"
            className={styles.label}
          >
            {label}
          </Text>
        )}
        <div className={styles.inner}>
          <textarea
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onClick={onClick}
            id={id}
            name={id}
            disabled={disabled}
            ref={ref}
            rows={rows}
            {...rest}
          />
        </div>
        {!!errorMessage && (
          <Text
            variant={textVariantsEnum.Text_sm}
            color="error-500"
            className={styles.errorMessage}
          >
            {errorMessage}
          </Text>
        )}
      </div>
    );
  }
);
